import React, { useState, useEffect, useRef } from 'react';

export const HapticBalance = ({ balance, label = "Balance" }) => {
  const [displayBalance, setDisplayBalance] = useState(balance);
  const [isAnimating, setIsAnimating] = useState(false);
  const [floatingRewards, setFloatingRewards] = useState([]);
  const prevBalanceRef = useRef(balance);
  const requestRef = useRef();

  useEffect(() => {
    // Ensure we are working with numbers and treat null/undefined as 0
    const prev = Number(prevBalanceRef.current || 0);
    const current = Number(balance || 0);

    if (current > prev && prev !== 0) {
      // Trigger animation for increase
      const diff = current - prev;
      setIsAnimating(true);
      
      // Add floating reward text
      const id = Date.now();
      setFloatingRewards(prev => [...prev, { id, amount: diff.toFixed(2) }]);
      setTimeout(() => {
        setFloatingRewards(prev => prev.filter(r => r.id !== id));
      }, 2000);

      // Roll animation
      let startTimestamp = null;
      const duration = 1200; // 1.2 seconds roll

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 3); // easeOutCubic
        
        const nextValue = prev + (current - prev) * easeProgress;
        setDisplayBalance(nextValue);

        if (progress < 1) {
          requestRef.current = requestAnimationFrame(step);
        } else {
          setDisplayBalance(current);
          setIsAnimating(false);
        }
      };

      requestRef.current = requestAnimationFrame(step);
    } else {
      // Immediate update for decrease or same
      setDisplayBalance(current);
      setIsAnimating(false);
    }

    prevBalanceRef.current = current;
    return () => cancelAnimationFrame(requestRef.current);
  }, [balance]);

  return (
    <div 
      className="haptic-balance-container" 
      style={{ 
        position: 'relative', 
        display: 'inline-flex', 
        alignItems: 'center',
        padding: '0 5px'
      }}
    >
      {floatingRewards.map(reward => (
        <span key={reward.id} className="winning-amount-float">
          +${reward.amount}
        </span>
      ))}
      <div 
        className={`text-org ${isAnimating ? 'balance-animating' : 'balance-pop'}`}
      >
        {label}: ${Number(displayBalance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </div>
    </div>
  );
};
